import { API_ROUTES } from "../constants/apiRoutes";
import { PackageResponse } from "../types/package";
import { packageClient } from "./axios";

export const getAllPackages = async (): Promise<PackageResponse> => {
  const res = await packageClient.get(API_ROUTES.PACKAGES);
  return res.data;
};
